<template>
  <div class="body" :style="'max-height:' + pageHeight + 'px;max-width:' + pageWidth + 'px;overflow: y;'">
    <el-row>
      <el-col :span="18">
        <div class="erp-left" :style="'height:' + leftHeight + 'px;overflow: y;'">
          <ListSearchToobar v-bind="searchToobarData" @search="init" v-model="searchRquest" />
          <div class="erp_list" :style="'height:'+ (leftHeight - 44) + 'px;'">
            <ul>
              <li v-for="(item, index) in erpListData" :key="index" @click="erpListClick(item,index)" :class="active == index ? 'isActive' : ''">
                <div>
                  <span class="erp-name">{{item.name}}</span>
                  <span :class="item.active ? 'stausGreen' : 'statusGrey'"></span>
                </div>
                <div style="margin-bottom: 64px;margin-top: 10px;height: 40px;">
                  <span v-if="item.url">{{item.url}}</span>
                  <span v-if="!item.url">{{$t('noFoundurl')}}</span><br/>
                  <span>{{$t('company') + '\xa0\xa0' + item.groupName}}</span>
                </div>
                <!-- <div>
                  <span>{{$t('initial_info')}}</span><br/>
                  <span>0001（{{$t('username')}}）</span><br/>
                  <span>iceqerp2021（{{$t('password')}}）</span>
                </div> -->
                <div>
                  <span>{{$t('expire_date') + '\xa0\xa0' + item.deadline.split(' ')[0]}}</span>
                </div>
                <div>
                  <span>{{$t('user_qty') + '\xa0\xa0' + item.maxUserNumber}}</span>
                  <span class="icon" style="float:right;cursor: auto"><i class="icon-color hover-none common-icon icon-visit"></i></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="erp-right" :style="'min-height:' + pageHeight + 'px;'">
          <ul>
            <li>
              <div class="item-name">{{itemErpList.name}}</div>
            </li>
            <li>
              <span class="item-url">{{$t('URL')}}</span>
              <!-- <span class="item-val-url" @click="onVisit" style="cursor:pointer" v-if="itemErpList.url">{{itemErpList.url}}</span> -->
              <a :href="itemErpList.url" class="item-val-url" v-if="itemErpList.url">{{itemErpList.url}}</a>
              <span class="item-val" v-else>{{$t('noFoundurl')}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('company')}}</span>
              <span class="item-val">{{itemErpList.groupName}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('cellphone')}}</span>
              <span class="item-val">{{itemErpList.telephone}}</span>
            </li>
            <li style="border: none">
              <span class="item-code">{{$t('email')}}</span>
              <span class="item-val">{{itemErpList.email}}</span>
            </li>
            <div class="line-10"></div>
            <li>
              <span class="item-code">{{$t('active_date')}}</span>
              <span class="item-val">{{(itemErpList.createdTime || '').split(' ')[0]}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('expire_date')}}</span>
              <span class="item-val">{{(itemErpList.deadline || '').split(' ')[0]}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('user_qty')}}</span>
              <span class="item-val">{{itemErpList.maxUserNumber}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('erp_status')}}</span>
              <span class="item-val" :class="itemErpList.active ? 'stausGreen' : 'statusGrey'"></span>
            </li>
            <div class="visit-but">
              <el-button type="primary" round @click="onVisit" :disabled="vistDisable" style="width: 100%" size="mini">{{ $t('visit') }}</el-button>
            </div>
            <div class="modify-but">
              <el-button type="default" round @click="onModify" :disabled="noData" style="width: 100%" size="mini">{{ $t('modify') }}</el-button>
            </div>
            <div class="renewal-but">
              <el-button type="default" round @click="onRenewal" :disabled="noData" style="width: 100%" size="mini">{{ $t('renewal') }}</el-button>
            </div>
          </ul>
        </div>
      </el-col>
    </el-row>
    <Footerbar>
      <!-- <el-button round @click="addNew" size="small">+ NEW ERP</el-button> -->
    </Footerbar>
    <el-dialog :visible.sync="dialogVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close>
      <div slot="title" class="dialog-title">
        {{$t('modify_erp_information')}}
      </div>
      <formPage ref="formpage" v-if="dialogVisible" :itemErpList='itemErpList' @dialogVisible='dialogVisibleVal' />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="handelSubmitClick" size="mini" style="width: 200px">{{ $t('submit') }}</el-button>
        <el-button type="default" round @click="handelCancelClick" size="mini" style="width: 200px">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogRenewalVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close>
      <div slot="title" class="dialog-title">
        {{ $t('renewal') }}
      </div>
      <div class="form-container" style="position: relative;">
        <el-form ref="form" label-position="top" :model="renewalForm" label-width="80px" class="order-form">
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('user_qty')" prop="userNumber">
                <el-input class="gray-theme" v-model.number="renewalForm.userNumber" @input="userqtyChange" placeholder="0"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('user_month')" prop="monthNumber">
                <el-input class="gray-theme" v-model.number="renewalForm.monthNumber" @input="monthChange"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('amount') + ': '" prop="userNumber">
                {{amount + ' ' + currency}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" round @click="handelRenewalSubmitClick" size="mini" style="width: 200px">{{ $t('submit') }}</el-button>
        <el-button type="default" round @click="handelRenewalCancelClick" size="mini" style="width: 200px">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import erpApi from '@/apis/erp';
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import formPage from './formPage';
import orderApi from '@/apis/order';
export default {
  name: 'ErpList',
  data() {
    return {
      screenWidth: 0,
      screenHeight: 0,
      leftHeight: 0,
      pageHeight: 0,
      pageWidth: 0,
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          {
            label: this.$t('product_name'),
            type: 'input',
            model: 'name'
          },
          {
            label: this.$t('company'),
            type: 'input',
            model: 'groupName'
          },
          {
            label: this.$t('email'),
            type: 'input',
            model: 'email'
          }
        ],
        iconName: 'icon-erp',
        componentName: this.$t('erp_list')
      },

      erpListInformation: [
        {
          label: this.$t('erp_group'),
          value: ''
        },
        {
          label: this.$t('group_code'),
          value: ''
        }
      ],
      vistDisable: false,
      noData: false,
      itemErpList: {},
      searchRquest: {
        name: '',
        groupName: '',
        email: ''
      },
      erpListData: [],
      appModuleList: [],
      active: 0,
      dialogVisible: false,
      dialogRenewalVisible: false,
      renewalForm: {
        userNumber: '',
        monthNumber: ''
      },
      amount: '',
      currency: ''
    };
  },

  computed: {
    htmlHeight() {
      const WindowHeight = window.innerHeight - 140 + 'px';
      return WindowHeight;
    },

    listHeight() {
      const WindowHeight = window.innerHeight - 200 + 'px';
      return WindowHeight;
    }
  },

  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    screenHeight: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    activeName: {
      immediate: true,
      handler: function (newVal) {
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    }
  },

  mounted() {
    this.init();
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = window.innerHeight;
        that.screenHeight = window.screenHeight;
      })();
    };
  },

  methods: {

    calculationSize() {
      const windowHeight = window.innerHeight;
      const navBarHeight = 80;
      const footerBarHeight = 60;
      this.pageHeight = windowHeight - navBarHeight - footerBarHeight;
      this.leftHeight = windowHeight - navBarHeight - footerBarHeight - 10;
      const windowWidth = window.innerWidth;
      this.pageWidth = windowWidth;
    },

    async init() {
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      const res = await erpApi.erpInstList(req);
      if (res.list.length === 0) {
        this.vistDisable = true;
        this.noData = true;
        return false;
      } else {
        this.erpListData = res.list;
        this.itemErpList = res.list[0];
        if (this.itemErpList.url) {
          this.vistDisable = false;
        } else {
          this.vistDisable = true;
        }
      }
      this.active = 0;
    },

    erpListClick(item, index) {
      this.itemErpList = { ...item };
      if (this.itemErpList.url) {
        this.vistDisable = false;
      } else {
        this.vistDisable = true;
      }
      this.active = index;
    },

    addNew() {
      this.dialogVisible = true;
    },

    onModify() {
      this.dialogVisible = true;
    },

    onRenewal() {
      this.dialogRenewalVisible = true;
    },

    dialogVisibleVal(val) {
      this.dialogVisible = val;
    },

    async handelSubmitClick() {
      const req = {
        ...this.$refs.formpage.formLabelAlign
      };
      const res = await erpApi.erpInstModify(req);
      if (res.reason) {
        alert('实例找不到');
      } else {
        this.dialogVisible = false;
        this.init();
      }
      this.active = 0;
    },

    handelCancelClick() {
      this.dialogVisible = false;
    },

    onVisit() {
      window.open(this.itemErpList.url, '_blank');
    },

    userqtyChange() {
      this.getCalculate();
    },

    monthChange() {
      this.getCalculate();
    },

    async getCalculate() {
      const req = {
        instId: this.itemErpList.id,
        userNumber: this.renewalForm.userNumber,
        monthNumber: this.renewalForm.monthNumber
      };
      const res = await orderApi.renewal(req);
      this.amount = res.payableAmount;
      this.currency = res.currency;
    },

    async handelRenewalSubmitClick() {
      const req = {
        instId: this.itemErpList.id,
        userNumber: this.renewalForm.userNumber,
        monthNumber: this.renewalForm.monthNumber
      };
      const res = await orderApi.renewalCreate(req);
      if (res.succeeded) {
        this.$message({
          message: this.$t('success'),
          type: 'success',
          duration: 5000
        });
        this.dialogRenewalVisible = false;
      }
    },

    handelRenewalCancelClick() {
      this.dialogRenewalVisible = false;
    }
  },

  components: {
    ListSearchToobar,
    Footerbar,
    formPage
  }
};
</script>

<style lang="scss" scoped>
.erp_list ul {
  text-align: left;
}

.erp_list li {
  width: 440px;
  height: 230px;
  display: inline-block;
  background-color: #fff;
  margin-left: 20px;
  margin-top: 45px;
  margin-bottom: 20px;
  padding: 30px;
  border-radius: 4px;
}

.erp_list {
  overflow-y: auto;
  width: 100%;
  background-color: #f4f4f4;
}

.erp-right li {
  border-bottom: 1px solid #f4f4f4;
  text-align: left;
  margin: 10px 0 6px;
}

.erp-right {
  background-color: #fff;
}

.erp-right ul {
  padding: 35px 20px 95px 40px;
  list-style: none;
  width: 100%;
}

.stausGreen {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #84ce97;
  float: right;
}

.statusGrey {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #c7c8c9;
  float: right;
}

.erp-name {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
}

.isActive {
  border: 1px solid #0a0aff;
}

.item-url {
  color: #292929;
  font-weight: bold;
  font-size: 14px;
}

.item-name {
  color: #0a0aff;
  font-weight: bold;
  font-size: 24px;
}

.item-code {
  color: #292929;
  font-weight: bold;
  font-size: 14px;
}

.item-val-url {
  color: #0a0aff;
  font-size: 14px;
  float: right;
}

.item-val {
  color: #666666;
  font-size: 14px;
  float: right;
}

.item-module {
  color: #292929;
  font-size: 14px;
}

.line-10 {
  width: 100%;
  height: 10px;
  background-color: #f4f4f4;
}

.visit-but {
  margin-top: 10px;
}

.modify-but,
.renewal-but {
  margin-top: 10px;
}

.hover-none:hover {
  color: #292929 !important;
}

.body {
height: 100%;
overflow: hidden;
min-width: 1366px;
}
</style>